import { RefObject, useEffect } from 'react';

const RTE_TOOLBAR_DROPDOWN_PORTAL = '[data-rte-toolbar-dropdown-portal]';

export const useOutsideClick = (
  ref: RefObject<HTMLElement | null>,
  callback: (event?: MouseEvent) => void,
  disable: boolean = false,
) => {
  useEffect(() => {
    if (disable) {
      return;
    }
    const handleClick = (e: MouseEvent) => {
      const target = e.target as Node;
      if (!ref.current) {
        return;
      }
      if (ref.current.contains(target)) {
        return;
      }
      const el = target instanceof Element ? target : target.parentElement;
      if (el?.closest(RTE_TOOLBAR_DROPDOWN_PORTAL)) {
        return;
      }
      callback(e);
    };
    document.addEventListener('mousedown', handleClick, true);
    return () => {
      document.removeEventListener('mousedown', handleClick, true);
    };
  });
};
